import {
  ArrowDownOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Modal, Row, Statistic } from "antd";
import React from "react";
import { Link } from "react-router-dom";

function IndividualInfoModal(props) {
  return (
    <Modal
      title={"User name"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <div className="flex justify-between mb-6">
        <Statistic
          title="CURRENT PROGRESS"
          value={40}
          prefix={<ArrowDownOutlined style={{ color: "red" }} />}
          suffix="% completed"
        />
        <Link to="/individual-perf">
          <Button>View more</Button>
        </Link>
      </div>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
          cursor: "pointer",
        }}
      >
        <div className="text-base pri-font mb-3">Plans</div>
        <Row gutter={12}>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "blue" }}
              prefix={<QuestionCircleOutlined />}
              title="OBJECTIVES"
              value={14}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "green" }}
              prefix={<CheckCircleOutlined />}
              title="GOALS"
              value={7}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "orange" }}
              prefix={<ClockCircleOutlined />}
              title="ACTIONS"
              value={5}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "red" }}
              prefix={<ExclamationCircleOutlined />}
              title="SUB ACTIONS"
              value={2}
            />
          </Col>
        </Row>
      </Card>
    </Modal>
  );
}

export default IndividualInfoModal;
